// extracted by mini-css-extract-plugin
export default {"select_treatment":"SelectTreatment_select_treatment__hn+sP","treatment_item":"SelectTreatment_treatment_item__kFrgv"};